module.exports = __webpack_public_path__ + "img/SignUp-mobile.7d8c943b.jpg";